export default __webpack_public_path__ + "static/media/login_main_logo.87e52fa2.png";